export enum RoutePath {
  Reservations = "/reservations",
  Dashboard = "/dashboard",
  DashboardExecutive = "/executiveDashboard",
  Resources = "/resources",
  ResourceDetail = "/resources/:id",
  Events = "/events",
  EventDetail = "/events/:id",
  EventDetailEdit = "/events/:id/edit",
  Occupation = "/occupation",
  Users = "/users",
  audit = "/audit",
  EventType = "/eventType",
}
